import React, { useState, useEffect, useRef} from 'react'
import {motion} from 'framer-motion'
import './Projects.css'
import funwithai from './assets/fun-with-ai.png'
import trivianight from './assets/trivia-night.png'
import ohtheplaces from './assets/oh-the-places.png'
import rancid from './assets/rancid.png'
import greekgodbod from './assets/greek-god-bod.png'
import tictactoe from './assets/tic-tac-toe.png'
import traveltracker from './assets/travel-tracker.png'
import github from './assets/github.png'
import link from './assets/link.png'
import agile from './assets/icons8-agile-32.png'
import hand from './assets/icons8-hand-cursor-30.png'

const Projects = () => {
  const [width, setWidth] = useState(0)
  const projects = useRef();

  useEffect(() => {
    setWidth(projects.current.scrollWidth - projects.current.offsetWidth)
  }, [])

  return (
    <motion.section 
    ref={projects} 
    className='projects'
    >
      <h1 className='projects-title'>PROJECTS</h1>
      <div className='arrow'>
          Click to drag
          <img src={hand} className='hand-icon' alt='click to drag'/>
      </div>
        <motion.div
        className='inner-projects' 
        drag='x'
        dragConstraints={{ right: 0, left: -width}}
        whileTap={{ cursor: "grabbing" }}
        >

      <div className='project-seven'>
        <img src={funwithai} alt='screenshot' className='fun-with-ai'/>
        <div className='icon-container'>
          <a href="https://fun-with-ai-gjax78.netlify.app/" target='blank' className='project-link'>
            <img src={link} className='link-icon' alt='link icon'/>
            Live Site
          </a>
          <a href="https://github.com/gjax78/fun-with-ai" target='blank' className='project-link'>
            <img src={github} className='github-icon-project' alt='github icon'/>
            View the Code
          </a>
          <a href="https://github.com/gjax78/fun-with-ai/projects/1" target='blank' className='project-link'>
            <img src={agile} className='agile-icon' alt='agile icon'/>
            Agile Project Board
          </a>
        </div>
        <p>A site that features the chatGPT API where users can select an AI engine to answer their questions. Randomized prompt presets will populate as placeholders to help generate ideas. There is a hidden Easter egg in the Cypress testing file - see if you can find it!</p>
      </div>


      <div className='project-one'>
        <img src={trivianight} alt='screenshot' className='trivianight'/>
      <div className='icon-container'>
        <a href="https://trivia-night-gjax78.vercel.app/" target='blank' className='project-link'>
          <img src={link} className='link-icon' alt='link icon'/>
          Live Site
        </a>
        <a href="https://github.com/gjax78/trivia-night" target='blank' className='project-link'>
          <img src={github} className='github-icon-project' alt='github icon'/>
          View the Code
        </a>
      </div>
      <p>'Trivia Night' helps generate trivia categories and questions. Users can save and remove the questions they want to use.</p>
      </div>


      <div className='project-two'>
        <img src={ohtheplaces} alt='screenshot' className='places'/>
        <div className='icon-container'>
          <a href="https://oh-the-places.netlify.app/" target='blank' className='project-link'>
            <img src={link} className='link-icon' alt='link icon'/>
            Live Site
          </a>
          <a href="https://github.com/gjax78/oh-the-places-youll-go" target='blank' className='project-link'>
            <img src={github} className='github-icon-project' alt='github icon'/>
            View the Code
          </a>
          <a href="https://github.com/gjax78/oh-the-places-youll-go/projects/1" target='blank' className='project-link'>
          <img src={agile} className='agile-icon' alt='agile icon'/>
            Agile Project Board
          </a>
        </div>
        <p>An interactive travel site where users can 'favorite' and search destinations to keep track of their bucket list.</p>
      </div>


      <div className='project-three'>
        <img src={rancid} alt='screenshot' className='rancid'/>
        <div className='icon-container'>
          <a href="https://rancid-tomatillos-gjax78.vercel.app/" target='blank' className='project-link'>
            <img src={link} className='link-icon' alt='link icon'/>
            Live Site
          </a>
          <a href="https://github.com/gjax78/rancid-tomatillos" target='blank' className='project-link'>
            <img src={github} className='github-icon-project' alt='github icon'/>
            View the Code
          </a>
          <a href="https://github.com/gjax78/rancid-tomatillos/projects/1" target='blank' className='project-link'>
            <img src={agile} className='agile-icon' alt='agile icon'/>
            Agile Project Board
          </a>
        </div>
        <p>A site that allows you to find tons of new movies to watch, read overviews, view trailers, and more. It features React Router and a 100% Lighthouse Score for accessibility.</p>
      </div>


      <div className='project-four'>
        <img src={greekgodbod} alt='screenshot' className='greek-god-bod'/>
        <div className='icon-container'>
          <a href="https://fe-greek-god-bod.herokuapp.com/" target='blank' className='project-link'>
            <img src={link} className='link-icon' alt='link icon'/>
            Live Site
          </a>
          <a href='https://github.com/gjax78/fe_greek_god_bod' target='blank' className='project-link'>
            <img src={github} className='github-icon-project' alt='github icon'/>
            View the Code
          </a>
        </div>
        <p>A website to help track your workouts and progress that features Websockets.</p>
      </div>


      <div className='project-six'>
        <img src={tictactoe} alt='screenshot' className='tictactoe'/>
        <div className='icon-container'>
          <a href="https://gjax78.github.io/tic-tac-toe/" target='blank' className='project-link'>
            <img src={link} className='link-icon' alt='link'/>
            Live Site
          </a>
          <a href="https://github.com/gjax78/tic-tac-toe" target='blank' className='project-link'>
            <img src={github} className='github-icon-project' alt='github icon'/>
            View the Code
          </a>
        </div>
        <p>An interactive tic-tac-toe website that is written in DRY, vanilla JavaScript and also features CSS animations.</p>
      </div>


      <div className='project-five'>
        <img src={traveltracker} alt='screenshot' className='traveltracker'/>
        <div className='icon-container'>
          <a href="https://github.com/gjax78/travel-tracker" target='blank' className='project-link'>
            <img src={github} className='github-icon-project' alt='github icon'/>
            View the Code
          </a>
        </div>
        <p>Object oriented vanilla JavaScript project that features GET & POST requests, along with unit & integration tests.</p>
      </div>


      </motion.div>
    </motion.section>
  )
}

export default Projects